import React from 'react';
import { Building2, Wrench } from 'lucide-react';

export type AppMode = 'hagia' | 'strand';

interface AppSwitcherProps {
  currentApp: AppMode;
  onSwitch: (app: AppMode) => void;
}

const AppSwitcher: React.FC<AppSwitcherProps> = ({ currentApp, onSwitch }) => {
  return (
    <div className="flex items-center space-x-2 bg-white bg-opacity-20 rounded-lg p-1">
      <button
        onClick={() => onSwitch('hagia')}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md transition-all duration-200 ${
          currentApp === 'hagia'
            ? 'bg-white text-green-600 shadow-md font-semibold'
            : 'text-white hover:bg-white hover:bg-opacity-10'
        }`}
      >
        <Wrench size={18} />
        <span className="text-sm">Hagia Service</span>
      </button>
      <button
        onClick={() => onSwitch('strand')}
        className={`flex items-center space-x-2 px-4 py-2 rounded-md transition-all duration-200 ${
          currentApp === 'strand'
            ? 'bg-white text-blue-600 shadow-md font-semibold'
            : 'text-white hover:bg-white hover:bg-opacity-10'
        }`}
      >
        <Building2 size={18} />
        <span className="text-sm">Strand Utleie</span>
      </button>
    </div>
  );
};

export default AppSwitcher;
